import { render, staticRenderFns } from "./IQButton.vue?vue&type=template&id=2b16a19a&scoped=true"
import script from "./IQButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IQButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQButton.vue?vue&type=style&index=0&id=2b16a19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16a19a",
  null
  
)

export default component.exports